import { Flex } from "antd";
import { FC } from "react";
import { Coords, TaskSetGeoLocation } from "tm-shared/types";

import { InfoRowList, TaskViewModal } from "@/features/TaskView/components";
import { PrimaryText } from "@/shared/ui/Typography";

interface SetGeoLocationViewModalProps {
    task: TaskSetGeoLocation;
    onClose: () => void;
}

const formatCoords = (geo: Coords) => {
    return `${geo.lat.toFixed(6)}, ${geo.lng.toFixed(6)}`;
};

export const SetGeoLocationViewModal: FC<SetGeoLocationViewModalProps> = ({
    task,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const { geo } = taskPayload;

    const hasGeo = !!geo;

    const infoRows = [
        {
            label: "Координати:",
            value: hasGeo ? (
                <a
                    href={`https://www.google.com/maps?q=${geo.lat},${geo.lng}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <PrimaryText ellipsis textColor={"accent"}>
                        {formatCoords(geo)}
                    </PrimaryText>
                </a>
            ) : (
                <PrimaryText>Не вдалося визначити</PrimaryText>
            ),
        },
        {
            label: "Точність:",
            value: hasGeo ? `${geo.accuracy} м.` : "—",
        },
    ];

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <InfoRowList items={infoRows} />
            </Flex>
        </TaskViewModal>
    );
};
